<div class="mt-32">
  <table class="tbl tbl--full tbl--hovered" sortable-table (sorted)="onChangeSorting($event)">
    <colgroup>
      <col width="4%" />
      <col width="5%" />
      <col width="14%" />
      <col width="15%" />
      <col width="20%" />
      <col width="12%" />
      <col width="12%" />
      <col width="12%" />
      <col width="4%%" />
    </colgroup>
    <thead>
      <tr>
        <th sortable-column="s_id">ID</th>
        <th sortable-column="sector_number_str">Участок</th>
        <th sortable-column="market_branch.mb_region">Регион</th>
        <th sortable-column="market_branch.mb_name">Филиал</th>
        <th sortable-column="districts[0].ct_name">Район</th>
        <th sortable-column="sector_role">Роль участка</th>
        <th sortable-column="partnership_name">Компания</th>
        <th sortable-column="sector_head.employee.full_name">Ответственное лицо</th>
        <th sortable-column="version_number">Версия</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let plot of data.sectors">
        <tr
          [ngClass]="{
            'bg-gray-bright-light': plot.s_id == (filter.sectorExpanded && filter.sectorExpanded.s_id),
            'color-gray-dark': !plot.is_visible
          }"
        >
          <td>{{ plot.s_id }}</td>
          <td>
            <div class="grid grid--gap-4">
              <div
                class="grid__box grid__box--size-min pt-4"
                (click)="
                  tableBlock.onChangePlotExpanded({
                    sector: plot,
                    state: 'open'
                  })
                "
                *ngIf="plot.s_id !== (filter.sectorExpanded && filter.sectorExpanded.s_id)"
              >
                <app-icon [size]="'10'" [glyph]="'arrow-right'" [class]="'cursor-pointer'"></app-icon>
              </div>
              <div
                class="grid__box grid__box--size-min pt-4"
                (click)="
                  tableBlock.onChangePlotExpanded({
                    sector: plot,
                    state: 'close'
                  })
                "
                *ngIf="plot.s_id == (filter.sectorExpanded && filter.sectorExpanded.s_id)"
              >
                <app-icon [size]="'10'" [glyph]="'arrow-down'" [class]="'cursor-pointer'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min">
                <app-role-access [action]="'disable'" [permission]="'sector.edit'" [placement]="'bottom-left'">
                  <a
                    class="link"
                    data-role-element
                    id="{{ 'appEditPlot' + plot.s_id }}"
                    [ngClass]="{
                      'link--dotted-gray-dark': !plot.is_visible,
                      'link--dotted-blue-dark': plot.is_visible
                    }"
                    [routerLink]="['/' + SECTORS_PATHS.sectors, plot.s_id]"
                  >
                    {{ plot.sector_number_str }}
                  </a>
                </app-role-access>
              </div>
            </div>
          </td>
          <td>{{ plot.market_branch.mb_region }}</td>
          <td>
            {{ plot.market_branch.mb_name }}
          </td>
          <td>
            <span *ngFor="let city of plot.districts">
              <span class="font-weight-bold">{{ city.ct_name }}: </span>
              <span *ngFor="let last = last; let district; of: city.districts">
                {{ district.district_name }}
                {{ last ? '' : ', ' }}
              </span>
            </span>
          </td>
          <td>
            {{ plot.sector_role | func : formatSectorRole }}
          </td>
          <td>
            {{ plot.partnership_name }}
          </td>
          <td>
            <a class="link" *ngIf="plot.sector_head" id="{{ 'appUserView' + plot.sector_head.u_id }}" [routerLink]="['/users', { u_id: plot.sector_head.u_id }]">{{
              plot.sector_head.employee && plot.sector_head.employee.full_name
            }}</a
            ><br />
            <span *ngIf="plot.sector_head" class="color-gray-dark">{{ plot.sector_head.employee.phone | phoneFormat }}</span>
          </td>
          <td>
            {{ plot.version_number }}
          </td>
        </tr>
        <tr *ngIf="plot.s_id == (filter.sectorExpanded && filter.sectorExpanded.s_id)">
          <td colspan="8" class="td--reset-padding">
            <div class="bg-gray-pale pt-16 pr-24 pb-24 pl-24">
              <div class="grid mb-24">
                <div class="grid__box grid__box--size-5">
                  <div class="tt-uppercase color-gray-dark">Головной офис участка</div>
                  <div class="grid mt-8">
                    <div class="grid__box grid__box--size-3">
                      <b>Адрес</b>
                    </div>
                    <div class="grid__box grid__box--size-9">
                      {{ plot.address }}
                    </div>
                  </div>
                  <div class="grid mt-4">
                    <div class="grid__box grid__box--size-3">
                      <b>Координаты GPS</b>
                    </div>
                    <div class="grid__box grid__box--size-9">
                      {{ plot.latitude }},
                      {{ plot.longitude }}
                    </div>
                  </div>
                </div>
              </div>
              <app-role-access [action]="'disable'" [permission]="'sector.edit'" [placement]="'bottom-left'">
                <a data-role-element class="link link--no-underline" id="{{ 'appEditPlot' + plot.s_id }}" [routerLink]="['/' + SECTORS_PATHS.sectors, plot.s_id]">
                  <button class="button" type="button">Редактировать участок</button>
                </a>
              </app-role-access>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tr *ngIf="!tableBlock.sectorsLoading && !data.sectors" class="tr--reset-highlight">
      <td colspan="8">
        <div class="ta-center color-gray-dark pt-32 mt-8">
          {{ Enums.tables.emptyDataMessage }}
        </div>
      </td>
    </tr>
  </table>
  <app-pagination *ngIf="!tableBlock.sectorsLoading && data.sectors && data.sectors.length" (onLoadPartial)="tableBlock.onLoadPartial($event)"></app-pagination>
</div>
